import { render, staticRenderFns } from "./PlayerAnnotation.vue?vue&type=template&id=23a1399d&scoped=true&"
import script from "./PlayerAnnotation.vue?vue&type=script&lang=js&"
export * from "./PlayerAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAnnotation.vue?vue&type=style&index=0&id=23a1399d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1399d",
  null
  
)

export default component.exports